import ChatApp from '../../Assets/Images/ChatApp.png'
import StackOverflow from '../../Assets/Images/StackOverflow.png'
import Calculator from '../../Assets/Images/Calculator.png'
import Portfolio from '../../Assets/Images/Portfolio.png'
// import ChatApp from '../../Assets/svg-images/ChatApp.svg'

export const projectsData = [
	{
		id: 1,
		projectName: 'Chat application',
		projectDesc: 'A responsive React.js app with one to one and group chat having features of notifications, online status, messages seen or not with the indication of single or double tick respectively.',
		tags: ['React.js', 'Javascript', 'HTML', 'CSS', 'Chakra UI', 'Node.js','Express.js', 'MongoDB', 'JWT Auth', 'bcryptjs', 'socket.io'	],
		code: ['https://github.com/thamizhanban666/chat-app-frontend', 'https://github.com/thamizhanban666/chat-app-backend'],
	//	demo: 'https://chat-app-thamizhanban.netlify.app',
		image: 'https://i.ytimg.com/vi/HggSXt1Hzfk/maxresdefault.jpg'
		//ChatApp
	},
	{
		id: 2,
		projectName: 'ecommerce project',
		projectDesc: 'A clone of ecommerce web app ',
		tags: ['React.js', 'Javascript', 'HTML', 'CSS', 'Bootstrap', 'Node.js', 'Express.js', 'MongoDB','Mongoose','JWT Auth', 'bcryptjs'],
		code: ['https://github.com/thamizhanban666/stack-overflow-clone-frontend', 'https://github.com/thamizhanban666/stack-overflow-clone-backend'],
	//	demo: 'https://stack-overflow-clone-thamizhanban.netlify.app/',
		image: 'https://raw.githubusercontent.com/keremcanb/ecommerce-app-mern-stack/master/uploads/ss1.jpg'
		//StackOverflow
	},
	{
		id: 3,
		projectName: 'social media app',
		projectDesc: 'A socila media app you cna create posts  update posts like posts   follow people see people posts and  onother things',
		tags: ['HTML', 'CSS', 'Javascript', 'nodejs' ,"express" , "mongodb"],
		code: ['https://github.com/thamizhanban666/my_Project/tree/main/calculator'],
	//	demo: 'https://thamizhanbanprojects.netlify.app/calculator',
		image: "https://camo.githubusercontent.com/cefc7d2762fbc9ae4ed9bba5720e18cd7f5d763af8ea8d3dfe37e2dff9229e89/68747470733a2f2f73332e616d617a6f6e6177732e636f6d2f6d65726e626f6f6b2f6769742b2f736f6369616c2e706e67"
		//Calculator
	},
	{
		id: 4,
		projectName: 'Portfolio',
		projectDesc: 'My personal portfolio which is you are currently viewing built with react.js',
		tags: ['React.js', 'Javascript', 'HTML', 'CSS', 'Material UI', 'Netlify'],
		code: ['https://github.com/thamizhanban666/thamizhanban-portfolio'],
	//	demo: 'https://thamizhanban.netlify.app/',
		image: Portfolio
	},
			
]